<template>
    <div class="nav bgw">
        <div class="htmldiv fs20">
            <template v-for="(item,key) in menuList">
                <template v-if="!item.isHide">
                    <template v-if="item.hasSons">
                        <div class="al hav am mr15 dinline-block tcenter cpointer prelative minwidth"
                            :class="menu == item.class ? 'active' : ''" 
                            :key="key">
                            <router-link :to="item.to">{{item.stitle}}</router-link>
                            <div class="snav tleft bgw prelative fs16 tc3">
                                <template v-for="(item2) in $params.newsType[item.root].children">
                                    <a v-if="$params.newsType[item2].link" :style="$params.newsType[item2].stitle == '供销行业职业技能等级评价' ? 'font-size: 14px;' : ''"  
                                        :href="$params.newsType[item2]['link']" 
                                        :key="item2" 
                                        target="_blank"
                                        class="dblock tcenter">
                                        {{$params.newsType[item2].stitle}}
                                    </a>
                                    <router-link v-else 
                                        :key="item2"
                                        :to="$params.newsType[item2].to" 
                                        class="dblock tcenter">
                                        {{$params.newsType[item2].stitle}}
                                    </router-link>
                                </template>
                               
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <a v-if="item.target" 
                            :href="item.to" 
                            :target="item.target" 
                            :key="key"
                            class="al">
                            {{item.stitle}}
                        </a>
                        <router-link v-else class="al dinline-block" 
                            :to="item.to"
                            :class="menu == item.class ? 'active' : ''" 
                            :key="item.id">
                            {{item.stitle}}
                        </router-link>
                    </template>
                </template>
            </template>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Navs',
    data: function () {
        return {
            menuList: {},
            menu: '',
            searchInput: '',
            showInput: true
        }
    },
    created() {
        this.getMenuList()
        this.getMenu()
    },
    watch: {
        $route: {
            handler(val, oldval) {
                this.getMenu()
            },
            deep: true  // 深度观察监听
        }
    },
    methods: {
        _searchInput() {
            this.$router.push({
                path: '/search?sInput=' + this.searchInput
            })
        },
        getMenuList() {
            this.menuList = this.$params.nav;
            console.log(this.menuList);
        },
        getMenu() {
            let baseDir = this.$params.baseDir
            if (this.$route.path.indexOf(baseDir + 'index') === 0)
                this.menu = 'index'
            else if (this.$route.path.indexOf(baseDir + 'edu') === 0)
                this.menu = 'edu'
            else if (this.$route.path.indexOf(baseDir + 'train') === 0)
                this.menu = 'train'
            else if (this.$route.path.indexOf(baseDir + 'news') === 0){
                if(this.$route.params){
                    if(this.$route.params.id == 28)
                        this.menu = 'download' 
                    else if(this.$route.params.id == 33)
                        this.menu = 'relative' 
                    else if(['99', '100'].indexOf(this.$route.params.id) !== -1)
                        this.menu = 'dz' 
                    else if(['116','109','93','94','95','110','111','116','96','112','113','114','115','106'].indexOf(this.$route.params.id)  !== -1)
                        this.menu = 'skill' 
                    else if(['104', '105'].indexOf(this.$route.params.id)  !== -1)
                        this.menu = 'jianjie' 
                    else
                        this.menu = 'news'
                }else
                    this.menu = 'news'
            }
                
            
        }
    }

}
</script>
<style>
.minwidth{
    min-width: 10%;
}
</style>